import pako from "pako";
import apiEndpoints from "./api-endpoints";
import downloadDataUrl from "./download-data-url";
export default {
    mixins: [apiEndpoints],
    data() {
        return {
            mapTokenPromise: null,
            apiRequestProgress: 100
        };
    },
    methods: {
        statusCentury(statuscode) {
            return Math.floor(statuscode / 100);
        },
        statusOk(statuscode) {
            return this.statusCentury(statuscode) == 2;
        },

        // use the standard error box ui to display errors.
        checkStatus(response, errorMessage) {
            if (!this.statusOk(response.status)) {
                console.log(response);
                this.showError(errorMessage);
                return false;
            }
            return true;
        },

        // note that if you put headers into fetch options, instead of the headers
        // argument, then ALL default headers will be replaced with those in fetchOptions
        apiRequest: function(
            route,
            params,
            body,
            headers = {},
            fetchOptions = {}
        ) {
            console.log("apiRequest");
            console.log("route: " + route);
            console.log("params: " + params);
            console.log("body: " + body);
            console.log("headers: " + headers);
            console.log("fetchOptions: " + fetchOptions);

            headers["Accept"] = headers["Accept"] || "application/json";

            let queryParams;
            if (
                route[0].toUpperCase() == "GET" ||
                route[0].toUpperCase() == "DELETE"
            ) {
                // get requests can not have a body, so we use the body field to encode
                // query parameters onto the url.
                if (body) {
                    queryParams = new URLSearchParams(body).toString();
                }
                body = null;
            } else {
                // flag that we are sending json unless
                // body is null or FormData, or the headers have a specified Content-Type already
                if (
                    body &&
                    !(body instanceof FormData) &&
                    headers["Content-Type"] === undefined
                ) {
                    body = JSON.stringify(body);
                    headers["Content-Type"] = "application/json";
                }
            }

            // populate authorization headers if logged in
            let userData;
            if ((userData = this.loadToken())) {
                headers["Authorization"] = "Bearer " + userData.token;
            }

            let endpoint = this.apiPrefix + route[1];
            if (Array.isArray(params)) {
                params.forEach(val => (endpoint += "/" + val));
            } else if (params !== null && params !== undefined) {
                endpoint += "/" + params;
            }

            console.log(endpoint);

            // URLify the address and add query parameters if needed
            endpoint = new URL(endpoint);
            if (queryParams) endpoint.search = queryParams;

            var options = Object.assign(
                {
                    method: route[0],
                    headers: headers,
                    body: body
                },
                fetchOptions
            );

            return fetch(endpoint, options)
                .then(r => {
                    // if we make it here then the network is connected.
                    this.$store.commit("setOnline");

                    // if we get 401 back from a request, ditch the token, and
                    // navigate us to the login page.
                    if (r.status == 401) {
                        this.clearToken();
                        this.$router.push("/");
                    }

                    // If we get 423 back from a request, the user account has been locked.
                    // Navigate to the account locked page.
                    if (r.status == 423) {
                        if (this.$route.path != "/locked") {
                            this.$router.push("/locked");
                        }
                    }

                    // for error reporting.
                    let responseClone = r.clone();
                    let contentType = r.headers.get("content-type");
                    if (contentType.includes("application/json")) {
                        return r
                            .json()
                            .then(js => {
                                return { status: r.status, body: js };
                            })
                            .catch(ex => {
                                console.error(
                                    "Error decoding JSON response from apiRequest."
                                );
                                console.log(ex);
                                console.error("Content of the response was:");
                                console.log(r);
                                responseClone.text().then(r => {
                                    // otherwise, print to console.
                                    console.error(
                                        "Text content of the response body was:"
                                    );
                                    console.log(r);
                                });
                            });
                    } else if (
                        this.statusOk(r.status) &&
                        contentType.includes("text/html")
                    ) {
                        // if the response was text/html it is likely
                        // a dd or message page so open in a new tab,
                        // unless it is the 404 redirect to the base html page.
                        console.log(
                            "API request returned plain HTML, processing...."
                        );
                        console.log(contentType);
                        return r.text().then(html => {
                            if (!html.includes("*SPABASE*")) {
                                var tab = window.open("about:blank", "_blank");
                                tab.document.write(html); // where 'html' is a variable containing your HTML
                                tab.document.close(); // to finish loading the page
                            } else {
                                console.error(
                                    "API request returned the HTML SPA framework.  This means the request endpoint was not found."
                                );
                            }
                        });
                    } else if (
                        contentType != null &&
                        this.statusOk(r.status) &&
                        (contentType.includes("text/plain") ||
                            contentType.includes("application/zip"))
                    ) {
                        return new Promise(async (resolve, reject) => {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                                resolve({
                                    status: r.status,
                                    headers: r.headers,
                                    body: reader.result
                                });
                            };
                            reader.onerror = reject;

                            const blob = await r.blob();
                            reader.readAsDataURL(blob);
                        });
                    } else {
                        // typically this will be content type 'application/octet-stream' for the binary log download.
                        if (!this.statusOk(r.status)) {
                            console.error(`HTTP Error ${r.status}:`);
                            return r.text().then(txt => {
                                console.log(txt);
                                if (!txt.includes("*SPABASE*")) {
                                    // usually in this instance the response is an error page, so
                                    // open it if we are in development mode
                                    if (Vue.config.devtools) {
                                        var myWindow = window.open();
                                        myWindow.document.write(txt);
                                        myWindow.document.close(); // to finish loading the page
                                    }
                                }
                            });
                            return Promise.resolve(null);
                        }

                        // the progress of a response is only applicable to
                        // blob downloads.
                        const contentLength = +r.headers.get("Content-Length");
                        console.log("Content length is ", contentLength);
                        let receivedLength = 0;
                        let chunks = [];
                        const reader = r.body.getReader();
                        this.apiRequestProgress = 0;

                        let readApiChunk = (readerArg, chunksArg) => {
                            return readerArg.read().then(({ done, value }) => {
                                if (done) {
                                    this.apiRequestProgress = 100;
                                    return chunksArg;
                                } else {
                                    chunksArg.push(value);
                                    receivedLength += value.length;
                                    this.apiRequestProgress =
                                        (receivedLength * 100) / contentLength;
                                    console.log(
                                        `Received ${this.apiRequestProgress}%`
                                    );
                                    return readApiChunk(readerArg, chunksArg);
                                }
                            });
                        };

                        return readApiChunk(reader, chunks)
                            .then(chunksArg => {
                                let chunksAll = new Uint8Array(receivedLength); // (4.1)
                                let position = 0;
                                for (let chunk of chunksArg) {
                                    chunksAll.set(chunk, position); // (4.2)
                                    position += chunk.length;
                                }

                                return {
                                    status: r.status,
                                    body: chunksAll
                                };
                            })
                            .catch(ex => {
                                console.error(
                                    "Error decoding Blob response from apiRequest."
                                );
                                console.log(ex);
                                console.error("Content of the response was:");
                                console.log(r);
                                responseClone.text().then(r => {
                                    console.error(
                                        "Text content of the response body was:"
                                    );
                                    console.log(r);
                                });
                            });
                    }
                })
                .catch(ex => {
                    // errors here indicate some network problem other than HTTP error codes
                    // so we can safely assume that we are offline if something is caught here.
                    this.$store.commit("setOffline");
                    console.error(
                        "Exception in promise of apiRequest fetch stage:"
                    );
                    console.error(ex);
                    if (!this.offlineRoutes.includes(this.$route.name)) {
                        this.$router.push("/offline");
                    }
                });
        }
    }
};
